import { OneWaitlistDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface Props {
  isAiChatActive: boolean
  aiEnabled: boolean
  employeeName: string
}

const useAiPromotion = ({ isAiChatActive, aiEnabled, employeeName }: Props) => {
  const { company, canRequestUpsell } = useCurrentSession()
  const { data: oneWaitlistData, loading: oneWaitlistLoading } = useQuery(OneWaitlistDocument, {
    variables: {
      companyId: company.id,
    },
  })

  const isAiAgentFeatureEnabled = !!oneWaitlistData?.features.featuresConnection.nodes[0]?.enabled
  // If client doesn't have One and is already on the waitlist
  const alreadyInOneWaitlist =
    oneWaitlistData?.companies.featureAvailabilitiesConnection.nodes[0]?.available === true &&
    !aiEnabled

  const handleOpen = () => {
    track(trackingEvents.upsell.viewOneSidepanel, {
      isOneActive: isAiChatActive,
      hasOnePolicy: aiEnabled,
      isAiAgentFeatureEnabled: isAiAgentFeatureEnabled,
      alreadyInOneWaitlist: alreadyInOneWaitlist,
      canJoinOneWaitlist: false,
    })
  }

  const handleClose = () => {
    track(trackingEvents.upsell.closeOneSidepanel, {
      isOneActive: isAiChatActive,
      hasOnePolicy: aiEnabled,
      isAiAgentFeatureEnabled: isAiAgentFeatureEnabled,
      alreadyInOneWaitlist: alreadyInOneWaitlist,
      canJoinOneWaitlist: false,
    })
  }

  const aiPromotionEnabled = !isAiChatActive && aiEnabled && canRequestUpsell

  const aiPromotion = {
    enabled: oneWaitlistLoading ? false : aiPromotionEnabled,
    greeting: i18n.t('common.ai.greeting', { name: employeeName }),
    onShow: handleOpen,
    onHide: handleClose,
    title: i18n.t('growth.sidepanel_chat.ai_disabled.subtitle'),
    description: i18n.t('growth.sidepanel_chat.ai_disabled.description'),
  }

  return { aiPromotion }
}

export default useAiPromotion
